// extracted by mini-css-extract-plugin
export default {"container":"gDeO172Y","overlay":"_267gwY7v","overlayText":"c4oxT4Ar","overlayBackground":"_1HH9R0BE","text":"_2CJhrSkF","illustration":"_2FB7mNtR"};